import _axios from 'axios';
// import qs from 'qs'
import { getAccessToken } from './mulesoftData.services';

class AppieigeDataService {
  constructor () {
    this.axios = _axios;
    this.api = this.axios.create({
      baseURL: process.env.REACT_APP_MULESOFT_API_ENDPOINT
    })
  }

  getExamseries() {
    return getAccessToken().then((res) => {
      return this.api({
        url: `/examseries`,
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${res}`
        }
      })
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = '/';
      }
    })
  }

//  getAccessToken() {
//   return _axios({
//     url: `${process.env.REACT_APP_MULESOFT_API_ENDPOINT_TOKEN}/token`,
//     method: 'post',
//     data: qs.stringify({
//       'grant_type': process.env.REACT_APP_MULESOFT_API_GRANT_TYPE,
//       'scope': process.env.REACT_APP_MULESOFT_API_SCOPE,
//       'client_id': process.env.REACT_APP_MULESOFT_API_CLIENT_ID,
//       'client_secret': process.env.REACT_APP_MULESOFT_API_CLIENT_SECRET
//     }),
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded'
//     }
//   })
//  }

}

const instance = new AppieigeDataService();
  Object.freeze(instance);
  
export default instance;
